import React, { useState, useEffect } from 'react'
import { API_URL, customStyles, storedData, secret_key, formatDate } from '../Constants';
import Swal from "sweetalert2";
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Modal from 'react-modal';
import { Link, useNavigate } from 'react-router-dom';
import loading1 from "../../assets/loading.gif"

const customStylesforMsg = {
  content: {
    top: '30%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minWidth: '350px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    marginTop: '40px'
  },
};


function ImportMessages() {
    const [searchTerm, setSearchTerm] = useState('');
    const [importMessages, setImportMessages] = useState([]);
    const [loading, setLoading] = useState(true);

    const [importMessagesdata, setnewImportMessagesData] = useState({
        subject: "",
        description: ""
    });

    let navigate = useNavigate()

    if (storedData) {
        var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
        var logeduserData = JSON.parse(bytes?.toString(CryptoJS.enc.Utf8));
      }
 
    const handleChange = (e) =>{
      const newdata = { ...importMessagesdata }
      newdata[e.target.id] = e.target.value
      setnewImportMessagesData(newdata)
  } 

  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;

    const fetchImportMessages = () => {
      let getimportMessagesConfig = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${API_URL}/get_imported_messages/${logeduserData?.company_id}`,
        headers: { 
          'Authorization': token
        }
      };

      axios
      .request(getimportMessagesConfig)
      .then((response) => {
        setImportMessages(response.data)
        setLoading(false);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          navigate(0);
        }
        setLoading(false);
      });
    };
  
    useEffect(() => {
      fetchImportMessages();
    }, []);

    const [companydata, setcompanydata] = useState("");

  //Get company by id
  const fetchCompanyByID = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${API_URL}/get_company/${logeduserData?.company_id}`,
      headers: { 
        'Authorization': token
      }
    };
    
    axios.request(config)
    .then((response) => {
      setcompanydata(response.data)
    })
    .catch((error) => {
      if (error?.response?.status === 401) {
        navigate(0);
      }
    });
  };

  useEffect(() => {
    fetchCompanyByID();
  }, []);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
      };

    const filteredImportMessages = importMessages.filter((importMessage) => {
    const { message_subject, message_body, created_at } = importMessage;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
        message_subject.toLowerCase().includes(lowerCaseSearchTerm) ||
        message_body.toLowerCase().includes(lowerCaseSearchTerm) ||
        created_at.toLowerCase().includes(lowerCaseSearchTerm)
    );
    });
    
    //Create message header
    const [modalIsOpen, setIsOpen] = useState(false);

    const openModal = () => {
      setIsOpen(true);
    }

    const closeModal = () => {
      setIsOpen(false);
    }

    const [isSubmitting, setIsSubmitting] = useState(false);
    const insertHeader = (ev) => {
      ev.preventDefault();

      if (isSubmitting) {
        return;
      }
  
      setIsSubmitting(true);

      let newImportMessages_data = {
        message_subject: importMessagesdata.subject,
        message_body: importMessagesdata.description,
        rate: companydata.rate,
        company_id: logeduserData?.company_id,
      };
      
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${API_URL}/post_import_messageHeader`,
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': token
        },
        data : newImportMessages_data
      };
      
      axios.request(config)
      .then((response) => {
        setTimeout(() => {
          setIsSubmitting(false);
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "New message was created successfully",
          })
          .then(() => {
            navigate(0)
          });
        }, 1000);
      })
      .catch((error) => {
        setIsSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data?.error,
        })
      });
    }

    //edit modal
const [editmodalIsOpen, setEditIsOpen] = useState(false);
const [editsms, seteditSms] = useState({
  subject: "",
  description: ""
});
const [smstoedit, setSmstoedit] = useState("");

const openEditModal = (messageid) => {
  setEditIsOpen(true);
  setSmstoedit(messageid)

    const getSmsByID = () => {
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${API_URL}/get_message_id/${messageid}`,
        headers: { 
          'Authorization': token
        }
      }
      
      axios.request(config)
      .then((response) => {
        const { message_subject, message_body } = response.data;
        seteditSms({
          subject: message_subject,
          description: message_body
        });     
      })
      .catch((error) => {
        console.log(error?.response)
      });
    };
    
    getSmsByID();
}

const closeEditModal = () => {
  setEditIsOpen(false);
}

const handleEditChange = (e) => {
  const editsmsdata = { ...editsms }
  editsmsdata[e.target.id] = e.target.value
  seteditSms(editsmsdata)
}

const editSmsDetails =(e) => {
  e.preventDefault()

  if (isSubmitting) {
    return;
  }

  setIsSubmitting(true);

  let config = {
    method: 'put',
    maxBodyLength: Infinity,
    url: `${API_URL}/edit_sms_header/${smstoedit}`,
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': token
    },
    data : editsms
  };
  
  axios.request(config)
  .then((response) => {
    setIsSubmitting(false);
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: "Message has been edited",
    })
    .then(() => {
      navigate(0)
    });
  })
  .catch((error) => {
    setIsSubmitting(false);
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: error?.response?.data?.error,
    })
  });
}
    
const deleteMessage = (messageID) => {
  Swal.fire({
    title: 'Are you sure you want to delete?',
    text: 'This action cannot be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
  }).then((result) => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    if (result.isConfirmed) {
      let config = {
        method: 'delete',
        maxBodyLength: Infinity,
        url: `${API_URL}/deleteImportedMessageAndLines/${messageID}`,
        headers: { 
          'Authorization': token
        }
      };
      
      axios.request(config)
      .then((response) => {
        setTimeout(() => {
          setIsSubmitting(false);
          Swal.fire({
            title: 'Deleted!',
            text: 'The message has been deleted.',
            icon: 'success',
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false
          })
          .then(() => {
            navigate(0);
          });
        }, 1000);
      })
      .catch((error) => {
        setIsSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data?.error,
        })
      });
    }
  });
}

  return (
    <div style={{paddingLeft:'10px'}}>
      {isSubmitting && (
        <div className="loadingsubcontainer loading-overlay">
          <img className="loadingsubimg" src={loading1} alt="" />
        </div>
      )}
      <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Imported Messages</h1>
                </div>{/* /.col */}
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Imported Messages</li>
                  </ol>
                </div>{/* /.col */}
              </div>{/* /.row */}
            </div>{/* /.container-fluid */}
        </div>
        {/* {modalOpen && <NewCompanyModal setOpenModal={setModalOpen} />} */}
        {/* <button id="add-btn">Add Company</button> */}

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStylesforMsg}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              <i className="fa fa-plus" style={{ marginRight: '8px' }}></i>
              New
              <i onClick={closeModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            
              <form onSubmit={insertHeader}>
                <div className="content">
                  <div className="user-details">
                  
                    <div className="input-box">
                      <span className="details">Subject</span>
                      <input type="text" 
                        placeholder="Enter message subject" 
                        className='unitsINPUT'
                        required 
                        onChange={handleChange}
                        id='subject'
                      />
                    </div>                  
                  </div>
                  <div className="user-details">
                  
                    <div className="input-box">
                      <span className="details">Description</span>
                      <input type="text" 
                        placeholder="Enter message description" 
                        className='unitsINPUT'
                        required 
                        onChange={handleChange}
                        id='description'
                      />
                    </div>                  
                  </div>
                
                  <div className="button">
                    <input type="submit" defaultValue="Save" />
                  </div>
              </div>
              </form>
      
          </div>

        </Modal>


        <Modal
          isOpen={editmodalIsOpen}
          onRequestClose={closeEditModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              Edit Message
              <i onClick={closeEditModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="content">
              <form onSubmit={editSmsDetails}> 
                <div className="content">
                  <div className="user-details">
                  
                    <div className="input-box">
                      <span className="details">Subject</span>
                      <input type="text" 
                        placeholder="Enter message subject" 
                        className='unitsINPUT'
                        required 
                        onChange={handleEditChange}
                        id='subject'
                        value={editsms.subject}
                      />
                    </div>                  
                  </div>
                  <div className="user-details">
                  
                    <div className="input-box">
                      <span className="details">Description</span>
                      <input type="text" 
                        placeholder="Enter message description" 
                        className='unitsINPUT'
                        required 
                        onChange={handleEditChange}
                        id='description'
                        value={editsms.description}
                      />
                    </div>                  
                  </div>
                
                  <div className="button">
                    <input type="submit" defaultValue="Update" />
                  </div>
                </div>
              </form>
            </div>
          </div>

        </Modal>

      <form className="form-inline justify-content-end searchBar">
        <div id="add-btn" onClick={openModal}>
          <i className="fa fa-plus" style={{ marginRight: '8px' }}></i>
          New </div>

        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>

      {loading ? (
          <div className="loadingsubcontainer">
            <img className="loadingsubimg" src={loading1} alt="" />
          </div>
        ) : (
      <div className='table-responsive p-0'>
        <table id="example" className="table table-striped">
        <thead>
            <tr>
                <th>SNo</th>
                <th>Subject</th>
                <th>Description</th>
                <th>Created At</th>
                <th>Status</th>
                <th>Action</th>
              
            </tr>
        </thead>
        <tbody>
          {filteredImportMessages.map((importMessages, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>
                <Link to={`/import_lines/${importMessages.id}`}>{importMessages.message_subject}</Link>
              </td>
              <td>{importMessages.message_body}</td>
              <td>{formatDate(importMessages.created_at)}</td>
              <td>{importMessages?.status == 1 ? (<span className='sendSMS'>Sent</span>) : (<span className='notsendSMS'>Draft</span>)}</td>
              <td className="dropdown">
                <button className="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Action
                  <span className="caret" /></button>
                <ul className="dropdown-menu companyActions">
                  {importMessages?.status == 1 ? "" : (<li onClick={() => openEditModal(importMessages.id)}><i className="fa fa-edit"></i>Edit Message</li>)}
                  {importMessages?.status == 1 ? "" : (<li onClick={() => deleteMessage(importMessages.id)}><i className="fa fa-trash"></i>Delete Message</li>)}
                  {importMessages?.status == 0 ? "" : (<li><i className="fa-sharp fa-solid fa-eye"></i><Link to={`/import_lines/${importMessages.id}`} className='download-link'>View Messages</Link></li>)}
                </ul>
              </td>

            </tr>
          ))}
        </tbody>
    </table>
        </div>
        )}
        
    </div>
  )
}

export default ImportMessages